import { Component, OnInit, OnDestroy } from '@angular/core';
import { LoaderService, LoaderState, LazyLoaderState } from '@app/core/services/loader/loader.service';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-lazy-loader',
  templateUrl: './lazy-loader.component.html',
  styleUrls: ['./lazy-loader.component.css']
})
export class LazyLoaderComponent implements OnInit {
  lazyshow = false;
  lazysubscription!: Subscription;
  constructor(private lazyloaderService: LoaderService) { }

  ngOnInit() {
    this.lazysubscription = this.lazyloaderService.lazyloaderState
    .subscribe((state: LazyLoaderState) => {
      this.lazyshow = state.lazyshow;
    });
  }
  // tslint:disable-next-line:use-life-cycle-interface
  ngOnDestroy() {
    this.lazysubscription.unsubscribe();
  }
}
